<div class="loading-container" [ngClass]="{'full-page': pageLoading}">
  <span></span>
</div>